export const SHORTCUT_SHOP_FIELDS = `
  id
  slug
  name
  customerName
  phone

  address
  geo_delivery_zone
  shopGeoPoint {
    latitude
    longitude
  }
  status

  min_price
  minOrderCost

  open_time
  close_time


  isPickupDeliveryAvailable
  shopPickupDeliveryCost

  tzOffset
  brand_id
  appStyle
`

export const BRAND_SHORTCUT = `
  brand {
    id
    logo(style: $style) {
      url
    }
    squareLogo {
      url
    }
    primaryColorHex
    primaryTextColorHex
  }
`

export const SHOPTAG_SHORTCUT = `
  shopTags {
    id
    name
    icon(style: $iconStyle) {
      url
    }
  }
`

export const SHOPIMAGES_SHORTCUT = `
  images(style: $shopImageStyle) {
    url
  }
`

export const SHOPSLOT_SHORTCUT = `
  firstAvailableSlot {
    id
    slotTime
    slotDate
    period {
      from
      to
    }
    availableUntil
  }
`

export const FULL_SHOP_SHORTCUT = `
  ${SHORTCUT_SHOP_FIELDS}
  ${SHOPSLOT_SHORTCUT}
  ${SHOPIMAGES_SHORTCUT}
  ${BRAND_SHORTCUT}
  ${SHOPTAG_SHORTCUT}
  ${SHOPIMAGES_SHORTCUT}
`
export const FULL_SHOP_SHORTCUT_WITHOUT_SLOT = `
  ${SHORTCUT_SHOP_FIELDS}
  ${SHOPIMAGES_SHORTCUT}
  ${BRAND_SHORTCUT}
  ${SHOPTAG_SHORTCUT}
  ${SHOPIMAGES_SHORTCUT}
`